import { createRouter, createWebHistory } from 'vue-router'
import { hasRole, isSuperAdmin } from './utils/auth'

const routes = [
  {
    path: '/login',
    name: 'FormLogin',
    component: () => import('./views/Formlogin/FormLogin.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    redirect: () => {
      // 检测是否为移动设备
      const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      // 检测屏幕宽度
      const isSmallScreen = window.innerWidth < 768;
      
      if (isMobileDevice || isSmallScreen) {
        return '/mobile/home';
      } else {
        return '/dashboard';
      }
    }
  },
  {
    path: '/dashboard',
    name: 'MainDashboard',
    component: () => import('./views/MainDashboard.vue')
  },
  {
    path: '/messagelist',
    name: 'MessageList',
    component: () => import('./views/settings/MessageList.vue')
  },
  {
    path:'/messageDetail',
    name: 'MessageDetail',
    component: () => import('./views/settings/MessageDetail.vue')
  },
  {
    path: '/Sales/Customers',
    name: 'Customers',
    component: () => import('./views/Sales/CustomerList.vue')
  },
  {
    path: '/Sales/CustomerAdd',
    name: 'CustomerAdd',
    component: () => import('./views/Sales/CustomerAdd.vue')
  },
  {
    path: '/Sales/SalesAdd',
    name: 'SailsAdd',
    component: () => import('./views/Sales/SalesAdd.vue')
  },
  {
    path: '/Sales/SalesListOrder',
    name: 'SalesListOrder',
    component: () => import('./views/Sales/SalesListOrder.vue')
  },
  {
    path: '/Sales/SalesDetailList',
    name: 'SalesDetailList',
    component: () => import('./views/Sales/SalesDetailList.vue')
  },
  {
    path: '/Sales/SalesReturnList',
    name: 'SalesReturnList',
    component: () => import('./views/Sales/SalesReturnList.vue')
  },
  {
    path: '/Sales/SalesReturnAdd',
    name: 'SalesReturnAdd',
    component: () => import('./views/Sales/SalesReturnAdd.vue')
  },
  {
    path: '/Sales/SalesReport',
    name: 'SalesReport',
    component: () => import('./views/Reports/SalesReport.vue')
  },
  {
    path: '/Sales/SalesReportMobile',
    name: 'SalesReportMobile',
    component: () => import('./views/Reports/SalesReportMobile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/inventory/InventoryCheckList',
    name: 'InventoryCheckList',
    component: () => import('./views/Inventory/InventoryCheckList.vue')
  },
  {
    path: '/inventory/InventoryCheckAdd',
    name: 'InventoryCheckAdd',
    component: () => import('./views/Inventory/InventoryCheckAdd.vue')
  },
  {
    path: '/inventory/InventoryCheckAdd/:id',
    name: 'InventoryCheckEdit',
    component: () => import('./views/Inventory/InventoryCheckAdd.vue')
  },
  {
    path: '/inventory/InventoryCheckDetail',
    name: 'InventoryCheckDetail',
    component: () => import('./views/Inventory/InventoryCheckDetail.vue')
  },
  {
    path: '/inventory/AssemblyAdd',
    name: 'AssemblyAdd',
    component: () => import('./views/Inventory/AssemblyAdd.vue')
  },
  {
    path: '/inventory/AssemblyList',
    name: 'AssemblyList',
    component: () => import('./views/Inventory/AssemblyList.vue')
  },
  {
    path: '/inventory/OtherTransferAdd',
    name: 'OtherTransferAdd',
    component: () => import('./views/Inventory/OtherTransferAdd.vue')
  },
  {
    path: '/inventory/OtherTransferList',
    name: 'OtherTransferList',
    component: () => import('./views/Inventory/OtherTransferList.vue')
  },
  // 兼容性路由
  {
    path: '/inventory/OtherInboundAdd',
    name: 'OtherInboundAdd',
    component: () => import('./views/Inventory/OtherTransferAdd.vue')
  },
  {
    path: '/inventory/OtherInboundList',
    name: 'OtherInboundList',
    component: () => import('./views/Inventory/OtherTransferList.vue')
  },
  {
    path: '/inventory/OtherOutboundAdd',
    name: 'OtherOutboundAdd',
    component: () => import('./views/Inventory/OtherTransferAdd.vue')
  },
  {
    path: '/inventory/OtherOutboundList',
    name: 'OtherOutboundList',
    component: () => import('./views/Inventory/OtherTransferList.vue')
  },
  // 财务管理路由
  {
    path: '/Finance/BankAccountList',
    name: 'BankAccountList',
    component: () => import('./views/Finance/BankAccountList.vue')
  },
  {
    path: '/Finance/BankAccountAdd',
    name: 'BankAccountAdd',
    component: () => import('./views/Finance/BankAccountAdd.vue')
  },
  {
    path: '/Finance/IncomeExpenseList',
    name: 'IncomeExpenseList',
    component: () => import('./views/Finance/IncomeExpenseList.vue')
  },
  {
    path: '/Finance/IncomeExpenseAdd',
    name: 'IncomeExpenseAdd',
    component: () => import('./views/Finance/IncomeExpenseAdd.vue')
  },
  {
    path: '/Finance/IncomeExpenseTypeList',
    name: 'IncomeExpenseTypeList',
    component: () => import('./views/Finance/IncomeExpenseTypeList.vue')
  },
  {
    path: '/Finance/ReceivableList',
    name: 'ReceivableList',
    component: () => import('./views/Finance/ReceivableList.vue')
  },
  {
    path: '/Finance/ReceiptList',
    name: 'ReceiptList',
    component: () => import('./views/Finance/ReceiptList.vue')
  },
  {
    path: '/Finance/ReceiptAdd',
    name: 'ReceiptAdd',
    component: () => import('./views/Finance/ReceiptAdd.vue')
  },
  {
    path: '/Finance/PayableList',
    name: 'PayableList',
    component: () => import('./views/Finance/PayableList.vue')
  },
  {
    path: '/Finance/PaymentList',
    name: 'PaymentList',
    component: () => import('./views/Finance/PaymentList.vue')
  },
  {
    path: '/Finance/PaymentAdd',
    name: 'PaymentAdd',
    component: () => import('./views/Finance/PaymentAdd.vue')
  },
  {
    path: '/Finance/SalesInvoiceList',
    name: 'InvoiceList',
    component: () => import('./views/Finance/SalesInvoiceList.vue')
  },
  {
    path: '/inventory/InventoryList',
    name: 'InventoryList',
    component: () => import('./views/Inventory/InventoryList.vue')
  },
  {
    path: '/inventory/in',
    name: 'StockIn',
    component: () => import('./views/Inventory/StockIn.vue')
  },
  {
    path: '/inventory/out',
    name: 'StockOut',
    component: () => import('./views/Inventory/StockOut.vue')
  },
  //进货管理路由
  {
    path: '/Purchase/PurchaseAdd',
    name: 'PurchaseAdd',
    component: () => import('./views/Purchase/PurchaseAdd.vue')
  },
  {
    path: '/Purchase/PurchaseListOrder',
    name: 'PurchaseListOrder',
    component: () => import('./views/Purchase/PurchaseListOrder.vue')
  },
  {
    path: '/Purchase/PurchaseDetailList',
    name: 'PurchaseDetailList',
    component: () => import('./views/Purchase/PurchaseDetailList.vue')
  },
  {
    path: '/Purchase/PurchaseReturnAdd',
    name: 'PurchaseReturnAdd',
    component: () => import('./views/Purchase/PurchaseReturnAdd.vue')
  },
  {
    path: '/Purchase/PurchaseReturnList',
    name: 'PurchaseReturnList',
    component: () => import('./views/Purchase/PurchaseReturnList.vue')
  },
  {
    path: '/Purchase/SupplierAdd',
    name: 'SupplierAdd',
    component: () => import('./views/Purchase/SupplierAdd.vue')
  },
  {
    path: '/Purchase/SupplierList',
    name: 'SupplierList',
    component: () => import('./views/Purchase/SupplierList.vue')
  },
  {
    path: '/Purchase/SupplierCategoryManage',
    name: 'SupplierCategoryManage',
    component: () => import('./views/Purchase/SupplierCategoryManage.vue')
  },
  {
    path: '/Purchase/PurchaseReport',
    name: 'PurchaseReport',
    component: () => import('./views/Purchase/PurchaseReport.vue')
  },
  // 财务管理路由
  {
    path: '/finance/invoice',
    name: 'Invoice',
    component: () => import('./views/Finance/InvoiceList.vue')
  },
  {
    path: '/Finance/InvoiceDetail',
    name: 'InvoiceDetail',
    component: () => import('./views/Finance/InvoiceDetail.vue')
  },
  {
    path: '/Finance/InvoiceApplicationListForSales',
    name: 'InvoiceApplicationListForSales',
    component: () => import('./views/Finance/InvoiceApplicationListForSales.vue')
  }, 
  {
    path: '/Finance/InvoiceApplicationList',
    name: 'InvoiceApplicationList',
    component: () => import('./views/Finance/InvoiceApplicationList.vue')
  },
  {
    path: '/Finance/InvoiceApplicationDetail',
    name: 'InvoiceApplicationDetail',
    component: () => import('./views/Finance/InvoiceApplicationDetail.vue')
  },
  {
    path: '/finance/payment',
    name: 'Payment',
    component: () => import('./views/Finance/PaymentProcess.vue')
  },
  {
    path: '/finance/fund-flows',
    name: 'FundFlows',
    component: () => import('./views/Finance/FinanceReports.vue')
  },
  // 核销单管理路由
  {
    path: '/Finance/WriteOffVoucherList',
    name: 'WriteOffVoucherList',
    component: () => import('./views/Finance/WriteOffVoucherList.vue')
  },
  {
    path: '/Finance/WriteOffVoucherCreate',
    name: 'WriteOffVoucherCreate',
    component: () => import('./views/Finance/WriteOffVoucherForm.vue')
  },
  {
    path: '/Finance/WriteOffVoucherEdit/:id',
    name: 'WriteOffVoucherEdit',
    component: () => import('./views/Finance/WriteOffVoucherForm.vue'),
    props: true
  },
  {
    path: '/Finance/WriteOffVoucherDetail/:id',
    name: 'WriteOffVoucherDetail',
    component: () => import('./views/Finance/WriteOffVoucherDetail.vue'),
    props: true
  },

  // 系统设置路由
  {
    path: '/settings/UserManagement',
    name: 'UserManagement',
    component: () => import('./views/settings/UserManagement.vue')
  },
  {
    path: '/settings/ChannelLevelConfigManagement',
    name: 'ChannelLevelConfigManagement',
    component: () => import('./views/settings/ChannelLevelConfigManagement.vue')
  },
  {
    path: '/settings/ChannelMerchantManagement',
    name: 'ChannelMerchantManagement',
    component: () => import('./views/settings/ChannelMerchantManagement.vue')
  },
  {
    path: '/settings/roles',
    name: 'Roles',
    component: () => import('./views/settings/UserRoles.vue')
  },
  {
    path: '/settings/salesman',
    name: 'SalesmanList',
    component: () => import('./views/settings/SalesmanList.vue')
  },
  {
    path: '/settings/salesman/add',
    name: 'SalesmanAdd',
    component: () => import('./views/settings/SalesmanAdd.vue')
  },
  {
    path: '/settings/salesman/edit/:id',
    name: 'SalesmanEdit',
    component: () => import('./views/settings/SalesmanAdd.vue'),
    props: true
  },
  {
    path: '/settings/warehouse',
    name: 'WarehouseList',
    component: () => import('./views/settings/WarehouseList.vue')
  },
  {
    path: '/settings/warehouse/add',
    name: 'WarehouseAdd',
    component: () => import('./views/settings/WarehouseAdd.vue')
  },
  {
    path: '/settings/warehouse/edit/:id',
    name: 'WarehouseEdit',
    component: () => import('./views/settings/WarehouseAdd.vue'),
    props: true
  },
  {
    path: '/settings/system',
    name: 'System',
    component: () => import('./views/settings/SystemSettings.vue')
  },
  {
    path: '/settings/message-config',
    name: 'MessageConfig',
    component: () => import('./views/settings/MessageConfig.vue')
  },
  {
    path: '/settings/ProductCreate',
    name: 'ProductCreate',
    component: () => import('./views/settings/ProductCreate.vue')
  },
  {
    path: '/settings/ProductManagement',
    name: 'ProductManagement',
    component: () => import('./views/settings/ProductManagement.vue')
  },
  {
    path: '/settings/CategoryManagement',
    name: 'CategoryManagement',
    component: () => import('./views/settings/CategoryManagement.vue')
  },
  {
    path: '/settings/data-authorization',
    name: 'DataAuthorization',
    component: () => import('./views/settings/DataAuthorization.vue')
  },
  {
    path: '/platform/companies',
    name: 'PlatformCompanyManagement',
    component: () => import('./views/platform/PlatformCompanyManagement.vue'),
    meta: {
      requiresAuth: true,
      roles: ['super_admin']
    }
  },
  // 一客一价管理路由
  {
    path: '/CustomerPrice/CustomerPriceIndex',
    name: 'CustomerPriceIndex',
    component: () => import('./views/CustomerPrice/CustomerPriceIndex.vue'),
    meta: {
      title: '一客一价管理',
      icon: 'fas fa-tags',
      roles: ['admin', 'manager', 'sales']
    }
  },
  {
    path: '/CustomerPrice/CustomerPriceList',
    name: 'CustomerPriceList',
    component: () => import('./views/CustomerPrice/CustomerPriceList.vue'),
    meta: {
      title: '价格列表',
      parent: 'CustomerPrice'
    }
  },
  {
    path: '/CustomerPrice/CustomerPriceAdd',
    name: 'CustomerPriceAdd',
    component: () => import('./views/CustomerPrice/CustomerPriceAdd.vue'),
    meta: {
      title: '新增价格',
      parent: 'CustomerPrice'
    }
  },
  {
    path: '/CustomerPrice/CustomerPriceHistory',
    name: 'CustomerPriceHistory',
    component: () => import('./views/CustomerPrice/CustomerPriceHistory.vue'),
    meta: {
      title: '价格历史',
      parent: 'CustomerPrice'
    }
  },
  {
    path: '/CustomerPrice/CustomerPriceCalculator',
    name: 'CustomerPriceCalculator',
    component: () => import('./views/CustomerPrice/CustomerPriceCalculator.vue'),
    meta: {
      title: '价格计算器',
      parent: 'CustomerPrice'
    }
  },
  // 报表管理路由
  {
    path: '/reports/employee-commission',
    name: 'EmployeeCommission',
    component: () => import('./views/Reports/EmployeeCommission/EmployeeReport.vue')
  },
  {
    path: '/reports/company-finance',
    component: () => import('@/views/Reports/CompanyFinanceReport.vue'),
    name: 'CompanyFinance',
  },
  {
    path: '/Reports/CustomerReport',
    name: 'CustomerReport',
    component: () => import('./views/Reports/CustomerReport.vue'),
    meta: {
      title: '客户报表',
      requiresAuth: true
    }
  },
  // 商城订单管理路由
  {
    path: '/ShopOrders/OrderList',
    name: 'ShopOrderList',
    component: () => import('./views/ShopOrders/OrderList.vue'),
    meta: {
      title: '商城订单管理',
      icon: 'fas fa-shopping-cart',
      roles: ['admin', 'manager']
    }
  },
  // 审批流程管理路由
  {
    path: '/settings/approval-workflows',
    name: 'ApprovalWorkflowList',
    component: () => import('./views/settings/ApprovalWorkflowList.vue'),
    meta: {
      title: '审批流程配置',
      icon: 'fas fa-sitemap',
      roles: ['admin', 'manager']
    }
  },
  // 系统配置管理路由
  {
    path: '/system/config',
    name: 'ConfigManager',
    component: () => import('./views/System/ConfigManager.vue'),
    meta: {
      title: '系统配置管理',
      icon: 'fas fa-cogs',
      roles: ['admin', 'manager']
    }
  },
  {
    path: '/approval/my-pending',
    name: 'MyPendingApprovals',
    component: () => import('./views/approval/MyPendingApprovals.vue'),
    meta: {
      title: '我的待办',
      icon: 'fas fa-clock',
      requiresAuth: true
    }
  },
  {
    path: '/approval/my-completed',
    name: 'MyCompletedApprovals',
    component: () => import('./views/approval/MyCompletedApprovals.vue'),
    meta: {
      title: '我的已办',
      icon: 'fas fa-check-circle',
      requiresAuth: true
    }
  },
  {
    path: '/approval/my-applications',
    name: 'MyApplications',
    component: () => import('./views/approval/MyApplications.vue'),
    meta: {
      title: '我的申请',
      icon: 'fas fa-file-alt',
      requiresAuth: true
    }
  },
  {
    path: '/approval/my-applications/:id',
    name: 'MyApplicationsDetail',
    component: () => import('./views/approval/MyApplicationsDetail.vue'),
    meta: {
      title: '申请详情',
      requiresAuth: true
    }
  },
  {
    path: '/approval/history/:instanceId',
    name: 'ApprovalHistory',
    component: () => import('./views/approval/ApprovalHistory.vue'),
    meta: {
      title: '审批历史',
      requiresAuth: true
    }
  },
  {
    path: '/approval/email-action/:token',
    name: 'EmailApprovalAction',
    component: () => import('./views/approval/EmailApprovalAction.vue'),
    meta: {
      title: '邮件审批',
      requiresAuth: false
    }
  },
  {
    path: '/approval/email-template-config',
    name: 'EmailTemplateConfig',
    component: () => import('./views/approval/EmailTemplateConfig.vue'),
    meta: {
      title: '邮件模板配置',
      icon: 'fas fa-envelope-open-text',
      requiresAuth: true
    }
  },
  {
    path:'/approval/email-approval',
    name:'EmailApproval',
    component: () => import('./views/approval/EmailApproval.vue'),
    meta: {
      title: '邮件审批',
      icon: 'fas fa-envelope-open-text',
      requiresAuth: false  // 免登录访问
    }
  },
  {
    path:'/approval/email-purchase-list',
    name:'EmailPurchaseList',
    component: () => import('./views/ApprovalV2/EmailPurchaseList.vue'),
    meta: {
      title: '查看进货单',
      icon: 'fas fa-shopping-cart',
      requiresAuth: false  // 免登录访问
    }
  },
  // 审批管理V2路由
  {
    path: '/approval-v2/payment',
    name: 'PaymentApprovalManagement',
    component: () => import('./views/ApprovalV2/PaymentApprovalManagement.vue'),
    meta: {
      title: '付款申请管理',
      icon: 'fas fa-money-bill-wave',
      requiresAuth: true
    }
  },
  {
    path: '/approval-v2/payment/add',
    name: 'PaymentAdd',
    component: () => import('./views/ApprovalV2/PaymentAdd.vue'),
    meta: {
      title: '新建付款申请',
      icon: 'fas fa-plus',
      requiresAuth: true,
      permissions: ['payment:create']
    }
  },
  {
    path: '/approval-v2/payment/edit',
    name: 'PaymentEdit',
    component: () => import('./views/ApprovalV2/PaymentEdit.vue'),
    meta: {
      title: '编辑付款申请',
      icon: 'fas fa-edit',
      requiresAuth: true,
      permissions: ['payment:edit']
    }
  },
  {
    path: '/approval-v2/invoice',
    name: 'InvoiceApprovalManagement',
    component: () => import('./views/ApprovalV2/InvoiceApprovalManagement.vue'),
    meta: {
      title: '发票申请管理',
      icon: 'fas fa-file-invoice',
      requiresAuth: true
    }
  },
  {
    path: '/approval-v2/invoice/add',
    name: 'InvoiceAdd',
    component: () => import('./views/ApprovalV2/InvoiceAdd.vue'),
    meta: {
      title: '新建发票申请',
      icon: 'fas fa-plus',
      requiresAuth: true,
      permissions: ['invoice:create']
    }
  },
  {
    path: '/approval-v2/invoice/edit',
    name: 'InvoiceEdit',
    component: () => import('./views/ApprovalV2/InvoiceEdit.vue'),
    meta: {
      title: '编辑发票申请',
      icon: 'fas fa-edit',
      requiresAuth: true,
      permissions: ['invoice:edit']
    }
  },
  {
    path: '/approval-v2/seal',
    name: 'SealApprovalManagement',
    component: () => import('./views/ApprovalV2/SealApprovalManagement.vue'),
    meta: {
      title: '印章申请管理',
      icon: 'fas fa-stamp',
      requiresAuth: true
    }
  },
  {
    path: '/approval-v2/seal/add',
    name: 'SealAdd',
    component: () => import('./views/ApprovalV2/SealAdd.vue'),
    meta: {
      title: '新建印章申请',
      icon: 'fas fa-plus',
      requiresAuth: true,
      permissions: ['seal:create']
    }
  },
  {
    path: '/approval-v2/seal/edit',
    name: 'SealEdit',
    component: () => import('./views/ApprovalV2/SealEdit.vue'),
    meta: {
      title: '编辑印章申请',
      icon: 'fas fa-edit',
      requiresAuth: true,
      permissions: ['seal:edit']
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const isLoginPage = to.path === '/login'
  
  // 如果访问的页面需要认证但没有token，则跳转到登录页
  if (to.meta.requiresAuth === true && !token && !isLoginPage) {
    // 保存当前要访问的页面URL，登录后跳转回来
    localStorage.setItem('returnUrl', to.fullPath)
    next('/login')
  } 
  // 如果已经登录且访问登录页，则跳转到首页
  else if (token && isLoginPage) {
    next('/')
  }
  else if (to.meta.roles && to.meta.roles.length > 0 && !to.meta.roles.some(role => hasRole(role)) && !isSuperAdmin()) {
    next('/')
  } 
  // 其他情况正常跳转
  else {
    next()
  }
})

export default router
